import { useCallback } from 'react';
import { useAccessToken } from '../core/workos/access-token.hook';
import { SignalRService } from './signalR.service';
import { ISignalRService } from './signalR.types';

export function useSignalRService(): ISignalRService {
  const { getAccessToken } = useAccessToken();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const accessTokenFactory = useCallback(async () => {
    const accessToken = await getAccessToken();
    return accessToken?.token ?? null;
  }, [getAccessToken]);

  const service = SignalRService.getService(accessTokenFactory);

  return service;
}
